// src/components/b2b/B2BLayout.js - B2B 전용 레이아웃

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import B2BSidebar from './B2BSidebar';
import { useAppContext } from '../../context/AppContext';
import './B2BLayout.scss';
import PageHeader from '../PageHeader';

const B2BLayout = ({
  children,
  hideCollapseButton = false,
  defaultCollapsed = false,
  hidePageHeader = false,
  navigationGuard,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);
  const { user, sessionChecked } = useAppContext();
  const navigate = useNavigate();

  const isEnterprise = user && user.tier === 'enterprise' && user.account_type === 'business';

  if (!sessionChecked) {
    return (
      <div className="b2b-layout">
        <div className="b2b-content">
          <div className="b2b-body">
            <div style={{ maxWidth: 480, margin: '80px auto', textAlign: 'center' }}>
              <p style={{ fontSize: '14px', color: '#6b7280' }}>로딩 중...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // 비밀번호 변경 필요 시 차단
  if (isEnterprise && user?.password_reset_required) {
    return (
      <div className="b2b-layout">
        <div className="b2b-content">
          <div className="b2b-body">
            <div style={{ maxWidth: 480, margin: '80px auto', textAlign: 'center' }}>
              <h2 style={{ fontSize: '20px', fontWeight: 700, marginBottom: '12px', color: '#111827' }}>
                비밀번호 변경이 필요합니다
              </h2>
              <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '20px' }}>
                보안을 위해 초기 비밀번호를 변경해야 서비스를 이용할 수 있습니다.
              </p>
              <button
                type="button"
                onClick={() => navigate('/change-password')}
                style={{
                  padding: '8px 16px',
                  borderRadius: '999px',
                  border: 'none',
                  backgroundColor: '#3A66FF',
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                비밀번호 변경하기
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="b2b-layout">
      {/* B2B 전용 사이드바 */}
      <B2BSidebar 
        isCollapsed={isCollapsed} 
        onToggleCollapse={
          hideCollapseButton
            ? undefined
            : () => setIsCollapsed((prev) => !prev)
        }
        hideToggleButton={hideCollapseButton}
        navigationGuard={navigationGuard}
      />

      {/* 메인 콘텐츠 영역 */}
      <div className="b2b-content">
        {!hidePageHeader ? <PageHeader /> : null}
        <div className="b2b-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default B2BLayout;
